import { Component, EventEmitter, Output, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetActionService } from '../../shared-services/widget-action.service';
import { Router } from '@angular/router';


export type NavbarAction =
  | 'edit'
  | 'filter'
  | 'removeFilter'
  | 'add'
  | 'delete'
  | 'status'
  | 'settings'
  | 'refresh'
  | 'savedFilters'
  | 'viewTransactions'
  | 'modelView'
  | 'explorer'
  | 'notifications'
  | string; // Allow dynamic actions

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {

  @Input() data: any;
  isOnline = true;

   constructor(private widgetActionService: WidgetActionService, private router: Router) {}

    @Output() action = new EventEmitter<NavbarAction>();




  onAction(action: string): void {

    console.log('NavbarComponent emitting action:', action);

    // Check if it's a dynamic menu action
    if (this.data?.menu) {
      const menuItem = this.data.menu.find((item: any) => item.actionId === action);
      if (menuItem?.path) {
        this.router.navigate([menuItem.path]);
        return;
      }
    }

    // Handle predefined actions
    if (action === 'quotes') {
      this.router.navigate(['/quotes']);
      return;
    }

    this.widgetActionService.emit({
    sourceWidgetId: 'widget10',   // MUST match JSON widgetId
    actionId: action              // add | delete | refresh | etc.
  });

    // emit to parent (recommended)
    // this.action.emit(action);

    // // optional local behavior examples
    // if (action === 'status') {
    //   this.isOnline = !this.isOnline; // toggle indicator demo
    // }
    // if (action === 'refresh') {
    //   // place refresh logic here
    //   // e.g., call a service or emit and handle in parent
    // }
  }
}

